if (!customElements.get('color-swatches')) {
  customElements.define(
    'color-swatches',
    class ColorSwatches extends HTMLElement {
      constructor() {
        super();
        this.colorOptions = this.querySelectorAll('[data-color-option]');
      }

      connectedCallback() {
        if (this.colorOptions.length === 0) return;
        this.colorOptions.forEach((option) => {
          option.addEventListener('click', (event) => this.changeProduct(event, option));
        });
      }

      async changeProduct(event, option) {
        event.preventDefault();
        const handle = option.dataset?.productHandle;
        if (!handle) return;
        this.colorOptions.forEach((option) => option.classList.remove('active'));
        option.classList.add('active');
        const url = `${window.Shopify.routes.root}products/${handle}?view=product-container`;
        const response = await fetch(url);
        const result = await response.text();
        const HTML = new DOMParser().parseFromString(result, 'text/html');
        const originalItem = this.closest('[data-product-grid-item]');
        const newItem = HTML.querySelector('[data-product-grid-item]');
        if (originalItem && newItem) {
          const originalImage = originalItem.querySelector('[data-product-image]');
          const newImage = newItem.querySelector('[data-product-image]');
          const originalInfo = originalItem.querySelector('[data-product-information]');
          const newInfo = newItem.querySelector('[data-product-information]');
          const originalURL = originalInfo.querySelector('[data-product-link]');
          const newURL = newInfo.querySelector('[data-product-link]');
          const originalPrice = originalInfo.querySelector('[data-product-price-holder]');
          const newPrice = newInfo.querySelector('[data-product-price-holder]');
          originalImage.innerHTML = newImage.innerHTML;
          originalURL.href = newURL.href;
          originalPrice.innerHTML = newPrice.innerHTML;
          if (window._swat && typeof _swat.initializeActionButtons === 'function') {
            _swat.initializeActionButtons('[data-product-grid-item]');
          }
        }
      }
    }
  );
}
